import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_COMING_SOON_MESSAGE]: 'COMING SOON: Available {date}',
  [StringId.DV_DP_COMING_SOON_TBC_DATE]: 'Coming soon',
  [StringId.DV_DP_COMING_IN_YEAR_MESSAGE]: 'Coming in {year}'
}
